import React from 'react';
import { Link } from 'react-router-dom';
import { placeholder } from '../../photos/index.js';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './ResourceCard.css';

const ResourceCard = ({ resource }) => {
  const publishDateLabel = useTranslatedText('Yayın Tarihi:');
  const authorLabel = useTranslatedText('Yazar:');

  if (resource.status === 'pending' || resource.status === 'rejected') {
    return null;
  }

  return (
    <Link to={`/resource/${resource.id}`} className="resource-link">
      <div className="resource-card">
        <div className="resource-image">
          <img
            src={resource.thumbnailUrl || placeholder}
            alt={resource.title}
            loading="lazy"
          />
        </div>
        <div className="resource-details">
          <h3>{resource.title}</h3>
          <div className="resource-date">
            <span>{publishDateLabel}</span> {resource.publishDate}
          </div>
          <div className="resource-author">
            <span>{authorLabel}</span> {resource.author}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ResourceCard;
